import { campaignsControllerGet } from '@/generated/korza-api-client';
import type { CampaignDto } from '@/generated/korza-api-client/types.gen';
import { useQuery } from '@tanstack/react-query';
import { useTenant } from './use-tenant';

export function useCampaign(campaignId: string) {
  const tenant = useTenant();

  return useQuery<CampaignDto>({
    queryKey: ['campaign', campaignId],
    queryFn: async () => {
      const res = await campaignsControllerGet({
        path: { tenantSlug: tenant.slug, campaignId },
        throwOnError: true,
      });
      return res.data;
    },
    enabled: !!campaignId,
  });
}
